import * as React from "react";
import PropTypes from "prop-types";
import { Input, makeResetStyles, Radio, RadioGroup,} from "@fluentui/react-components";
import { FluentTagPicker } from "../../../../components/FluentUI/Fluent-TagPicker";
import { FluentField } from "../../../../components/FluentUI/Fluent-Field";
import './sub-department.scss';

const useStackClassName = makeResetStyles({
  display: "flex",
  flexDirection: "column",
  rowGap: '12px',
  textAlign: "left",
});

export const GeneralProperties = ({ subDepartment, setSubDepartment, errors, setErrors }) => {

  const handleNameChange = (e) => {
    const name = e.target.value;
    setSubDepartment({ ...subDepartment, Name: name });

    if (name.trim()) {
      setErrors({ ...errors, Name: false });
    }
  };

  return (
    <div className={`${useStackClassName()} sub-department-general`}>

      <FluentField label="Sub-Department Name" required size="medium" validationMessage={errors.Name ? "Name is required" : ""}>
        <Input
          value={subDepartment?.Name}
          placeholder="Untitled Sub-Department"
          onChange={handleNameChange}
        />
      </FluentField>

      <FluentTagPicker
        options={subDepartment?.allDepartments}
        selectedOptions={subDepartment?.Departments}
        onOptionSelect={(newSelectedOptions) => setSubDepartment({ ...subDepartment, Departments: newSelectedOptions })}
        placeholder="Select Departments"
        label="Department(s)"
      />

      <FluentField label="Status" size="medium">
        <RadioGroup
          layout="horizontal"
          defaultValue={subDepartment?.Active}
          required
          onChange={(_, data) => setSubDepartment({ ...subDepartment, Active: data.value === "true" })}
        >
          <Radio value={true} label="Active" />
          <Radio value={false} label="Inactive" />
        </RadioGroup>
      </FluentField>
    </div>
  );
};

GeneralProperties.propTypes = {
  subDepartment: PropTypes.shape({
    Name: PropTypes.string,
    Departments: PropTypes.array,
    allDepartments: PropTypes.array,
    allTaskTypes: PropTypes.array,
    allProjectTemplates: PropTypes.array,
    DefaultProjectTemplate: PropTypes.shape({
      Id: PropTypes.number,
      ProjectType: PropTypes.string,
    }),
    DefaultTaskType: PropTypes.shape({
      Id: PropTypes.number,
      Type: PropTypes.string,
    }),
    Active: PropTypes.bool,
  }).isRequired,
  setSubDepartment: PropTypes.func.isRequired,
  errors: PropTypes.object.isRequired, 
  setErrors: PropTypes.func.isRequired,
};
